import { EPermissions } from '@common/definitions';

export interface CanListCustomUserPropertiesParams {
  organisationPermissions: string[];
  networkPermissionsById?: Record<string, string[] | undefined>;
}

/**
 * Mirrors node-api `assertCanListCustomUserProperties`:
 * org users.view / users.update, or network users.update on at least one community.
 */
export function canListCustomUserProperties({
  organisationPermissions,
  networkPermissionsById = {},
}: CanListCustomUserPropertiesParams): boolean {
  if (
    organisationPermissions.includes(EPermissions.ORGANISATION_USERS_VIEW)
    || organisationPermissions.includes(EPermissions.ORGANISATION_USERS_UPDATE)
  ) {
    return true;
  }

  return Object.values(networkPermissionsById).some((networkPermissions) => (
    Array.isArray(networkPermissions)
    && networkPermissions.includes(EPermissions.NETWORK_USERS_UPDATE)
  ));
}
